import {
    AbstractControl,
    UntypedFormBuilder,
    UntypedFormGroup,
    ValidationErrors,
    Validators
} from '@angular/forms';
import { ClientField } from '../../domain/models';

export class BackgroundForm {
    private static _phoneRegExp: RegExp =
        /^[(]?[0-9]{3}[)]?[-\s]?[0-9]{3}[-\s]?[0-9]{4}/;
    private static _fb: UntypedFormBuilder;

    static initialize(fb: UntypedFormBuilder): UntypedFormGroup {
        this._fb = fb;
        let formGroup = fb.group({
            applicationId: [undefined, Validators.required]
        });
        formGroup.addValidators(this.eligibilityCategoryValidator);
        formGroup.addValidators(this.eligibilityExplanationValidator);
        formGroup.addValidators(this.publicAssistanceValidator);
        return formGroup;
    }

    static setFields(fields: ClientField[], formGroup: UntypedFormGroup): void {
        fields.forEach((field) => {
            switch (field.fieldName) {
                case 'Ethnicity':
                    formGroup?.addControl(
                        'ethnicitySelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('ethnicitySelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'Race':
                    formGroup?.addControl(
                        'raceSelectionIds',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('raceSelectionIds')
                            ?.addValidators([Validators.required]);
                    break;
                case 'Barriers':
                    formGroup?.addControl(
                        'barrierSelectionIds',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('barrierSelectionIds')
                            ?.addValidators([Validators.required]);
                    break;
                case 'DisabilityYesNo':
                    formGroup?.addControl(
                        'disabilityYesNoSelectionId',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('disabilityYesNoSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'DisabilityAssistanceYesNo':
                    formGroup?.addControl(
                        'disabilityAssistanceSelectionId',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('disabilityAssistanceSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'Veteran':
                    formGroup?.addControl(
                        'veteranSelectionId',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('veteranSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'MilitaryServiceExperience':
                    formGroup?.addControl(
                        'militaryServiceExperienceSelectionId',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('militaryServiceExperienceSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'SelectiveServiceNotification':
                    formGroup?.addControl(
                        'selectiveServiceNotificationSelectionId',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('selectiveServiceNotificationSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'HomelessSite':
                    formGroup?.addControl(
                        'homelessSite',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('homelessSite')
                            ?.addValidators([Validators.required]);
                    break;
                case 'LaborForceStatus':
                    formGroup?.addControl(
                        'laborForceStatusSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('laborForceStatusSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'WorkStatus':
                    formGroup?.addControl(
                        'workStatusSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('workStatusSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'EmploymentStatus':
                    formGroup?.addControl(
                        'employmentStatusSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('employmentStatusSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'EmploymentStatusAlt':
                    formGroup?.addControl(
                        'employmentStatusAltSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('employmentStatusAltSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'EmploymentStatusTerse':
                    formGroup?.addControl(
                        'employmentStatusTerseSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('employmentStatusTerseSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'Employer':
                    formGroup?.addControl(
                        'employer',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('employer')
                            ?.addValidators([Validators.required]);
                    break;
                case 'Occupation':
                    formGroup?.addControl(
                        'occupation',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('occupation')
                            ?.addValidators([Validators.required]);
                    break;
                case 'RegisteredWithEmploymentAgency':
                    formGroup?.addControl(
                        'registeredWithEmploymentAgencySelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('registeredWithEmploymentAgencySelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'WioaPartnerPrograms':
                    formGroup?.addControl(
                        'wioaPartnerProgramSelectionIds',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('wioaPartnerProgramSelectionIds')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ReceivingPublicAssistance':
                    formGroup?.addControl(
                        'receivingPublicAssistanceSelectionIds',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('receivingPublicAssistanceSelectionIds')
                            ?.addValidators([Validators.required]);
                    break;

                case 'MaritalStatus':
                    formGroup?.addControl(
                        'maritalStatusSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('maritalStatusSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'FamilyIncome':
                    formGroup?.addControl(
                        'familyIncome',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('familyIncome')
                            ?.addValidators([Validators.required]);
                    break;
                case 'IncomePeriod':
                    formGroup?.addControl(
                        'incomePeriodSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('incomePeriodSelectionId')
                            ?.addValidators([Validators.required]);
                    break;

                case 'YourIncome':
                    formGroup?.addControl(
                        'yourIncome',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('yourIncome')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ImmigrationStatus':
                    formGroup?.addControl(
                        'immigrationStatusSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('immigrationStatusSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'HasF1OrJ1Visa':
                    formGroup?.addControl(
                        'hasF1OrJ1VisaSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('hasF1OrJ1VisaSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'CountryOfOrigin':
                    formGroup?.addControl(
                        'countryOfOriginSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('countryOfOriginSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'Disability':
                    formGroup?.addControl(
                        'disabilitySelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('disabilitySelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'DisabilityDocumented':
                    formGroup?.addControl(
                        'disabilityDocumentedSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('disabilityDocumentedSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'DisabilityAccommodations':
                    formGroup?.addControl(
                        'disabilityAccommodationsSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('disabilityAccommodationsSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ReferralSource':
                    formGroup?.addControl(
                        'referralSourceSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('referralSourceSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ReferralOrganizationName':
                    formGroup?.addControl(
                        'referralOrganizationName',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('referralOrganizationName')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ReferralContactName':
                    formGroup?.addControl(
                        'referralContactName',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('referralContactName')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ReferralContactPhone':
                    formGroup?.addControl(
                        'referralContactPhone',
                        this._fb.control(undefined, [
                            Validators.pattern(this._phoneRegExp)
                        ])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('referralContactPhone')
                            ?.addValidators([Validators.required]);
                    break;

                case 'CountryOfBirth':
                    formGroup?.addControl(
                        'countryOfBirthSelectionId',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('countryOfBirthSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'CitizenshipStatus':
                    formGroup?.addControl(
                        'citizenshipStatusSelectionId',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('citizenshipStatusSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ChildrenAges0To5':
                    formGroup?.addControl(
                        'childrenAges0To5',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('childrenAges0To5')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ChildrenAges6To10':
                    formGroup?.addControl(
                        'childrenAges6To10',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('childrenAges6To10')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ChildrenAges11To18':
                    formGroup?.addControl(
                        'childrenAges11To18',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('childrenAges11To18')
                            ?.addValidators([Validators.required]);
                    break;
                case 'MotherUnder17':
                    formGroup?.addControl(
                        'motherUnder17SelectionId',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('motherUnder17SelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ImmigrantStatus':
                    formGroup?.addControl(
                        'immigrantStatusSelectionId',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('immigrantStatusSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'RefugeeStatus':
                    formGroup?.addControl(
                        'refugeeStatusSelectionId',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('refugeeStatusSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'CorrectionsStatus':
                    formGroup?.addControl(
                        'correctionsStatusSelectionId',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('correctionsStatusSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ChildDependentCareNeeded':
                    formGroup?.addControl(
                        'childDependentCareNeededSelectionId',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('childDependentCareNeededSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'TransportationNeeded':
                    formGroup?.addControl(
                        'transportationNeededSelectionId',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('transportationNeededSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'EligibilityStatus':
                    formGroup?.addControl(
                        'eligibilityStatusSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('eligibilityStatusSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'EligibilityCategory':
                    formGroup?.addControl(
                        'eligibilityCategorySelectionId',
                        this._fb.control(undefined)
                    );
                    break;
                case 'EligibilityExplanation':
                    formGroup?.addControl(
                        'eligibilityExplanation',
                        this._fb.control(undefined)
                    );
                    break;
                case 'EligibilityConsent':
                    formGroup?.addControl(
                        'eligibilityConsentSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('eligibilityConsentSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
            }
        });
    }

    private static eligibilityCategoryValidator(
        control: AbstractControl
    ): ValidationErrors | null {
        const eligibilityStatusSelectionId = control.get(
            'eligibilityStatusSelectionId'
        );

        const eligibilityCategorySelectionId = control.get(
            'eligibilityCategorySelectionId'
        );
        const eligibilityCategorySelectionIdValue =
            eligibilityCategorySelectionId?.value;

        if (
            eligibilityCategorySelectionId &&
            (!eligibilityCategorySelectionIdValue ||
                (Array.isArray(eligibilityCategorySelectionIdValue) &&
                    eligibilityCategorySelectionIdValue.length === 0)) &&
            (eligibilityStatusSelectionId?.value == 1015 ||
                eligibilityStatusSelectionId?.value == 1016)
        )
            return { eligibilityCategoryRequired: true };

        return null;
    }

    public static eligibilityExplanationValidator(
        control: AbstractControl
    ): ValidationErrors | null {
        const eligibilityCategorySelectionId = control.get(
            'eligibilityCategorySelectionId'
        );
        const eligibilityExplanation = control.get('eligibilityExplanation');
        const eligibilityExplanationValue = eligibilityExplanation?.value;

        if (
            eligibilityExplanation &&
            (!eligibilityExplanationValue ||
                eligibilityExplanationValue.trim().length === 0) &&
            (eligibilityCategorySelectionId?.value == 1023 ||
                eligibilityCategorySelectionId?.value == 1024)
        ) {
            return { eligibilityExplanationRequired: true };
        }

        return null;
    }

    public static publicAssistanceValidator(
        control: AbstractControl
    ): ValidationErrors | null {
        const receivingPublicAssistanceSelectionIds = control.get(
            'receivingPublicAssistanceSelectionIds'
        );

        if (
            receivingPublicAssistanceSelectionIds &&
            Array.isArray(receivingPublicAssistanceSelectionIds.value) &&
            receivingPublicAssistanceSelectionIds.value.includes(80) &&
            receivingPublicAssistanceSelectionIds.value.length > 1
        ) {
            return { publicAssistanceInvalid: true };
        }

        return null;
    }
}
